import { 
    PRECIO_JUSTO_OPEN_MODAL_FROM_SEARCH_BUTTON,
    PRECIO_JUSTO_OPEN_MODAL_FROM_SIDEBAR,
    PRECIO_JUSTO_SAVE_CHANGES,
    PRECIO_JUSTO_DISCARD_CHANGES,
    PRECIO_JUSTO_CLOSE_MODAL
} from './constants'
import initialState from './initialState';

export function openModalFromSearchButton() {
    return (dispatch) => {
        dispatch({
            type: PRECIO_JUSTO_OPEN_MODAL_FROM_SEARCH_BUTTON,
        })
    }
}

export function openModalFromSidebar(nextLocation = null) {
    return (dispatch) => {
        dispatch({
            type: PRECIO_JUSTO_OPEN_MODAL_FROM_SIDEBAR,
            nextLocation
        })
    }
}

export function clickSaveChanges() {
    return (dispatch) => {
        dispatch({
            type: PRECIO_JUSTO_SAVE_CHANGES,
        })
    }
}

export function clickDiscardChanges() {
    return (dispatch) => {
        dispatch({
            type: PRECIO_JUSTO_DISCARD_CHANGES,
        })
    }
}

export function closeModal() {
    return (dispatch) => {
        dispatch({
            type: PRECIO_JUSTO_CLOSE_MODAL,
        })
    }
}

export function reducer(state = initialState, action = {}) {

    switch (action.type) {
        case PRECIO_JUSTO_OPEN_MODAL_FROM_SEARCH_BUTTON:
            return {
                ...state,
                modalConfirmationUsdData: {
                    ...state.modalConfirmationUsdData,
                    isOpen: true, 
                    openedFromSearchButton: true
                }
            }
        case PRECIO_JUSTO_OPEN_MODAL_FROM_SIDEBAR:
            return {
                ...state,
                modalConfirmationUsdData: {
                    ...state.modalConfirmationUsdData,
                    isOpen: true, 
                    openedFromSidebar: true,
                    nextLocation: action.nextLocation
                }
            }
        case PRECIO_JUSTO_SAVE_CHANGES:
            return {
                ...state,
                modalConfirmationUsdData: {
                    ...state.modalConfirmationUsdData,
                    saveChanges: true,
                }
            }
        case PRECIO_JUSTO_DISCARD_CHANGES:
            return {
                ...state,
                modalConfirmationUsdData: {
                    ...state.modalConfirmationUsdData,
                    discardChanges: true,
                }
            }
        case PRECIO_JUSTO_CLOSE_MODAL:
            return {
                ...state,
                modalConfirmationUsdData: {
                    isOpen: false, 
                    openedFromSearchButton: false,
                    openedFromSidebar: false,
                    saveChanges: null,
                    discardChanges: null,
                    nextLocation: null
                }
            }
        default:
            return state
    }
}